import React, { useContext, useEffect, useState } from "react";
import { Box, Paper, FormControl } from "@mui/material";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialInput from "../../../components/MaterialInput";
import MaterialButton from "../../../components/MaterialButton";
import MaterialSelect from "../../../components/MasterSelect";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ClearIcon from "@mui/icons-material/Clear";
import IconButton from "@mui/material/IconButton";
import colors from "../../../assest/theme/base/colors";
import Grid from "@mui/material/Grid2";
import { postItem, updateItem } from "../../../BaseUrl";
import { CREATECLIENT, UPDATECREATECLIENT } from "./Mutation";
import { UserContext } from "../../usercontext/usercontext";

const AddClientForm = ({
  formClose,
  countryState,
  industryData,
  setPopup,
  oneClientData,
  isView,
  setDialogData,
  handleOpenDialog,
  getClientData,
}) => {
  const { isuser } = useContext(UserContext);
  const [clientData, setClientData] = useState({
    clientName: "",
    industryType: "",
    hiringType: "",
    primaryContact: "",
    address: "",
    mapLocation: "",
    primaryEmail: "",
    primaryCountryCode: "",
    contactNumber: "",
    // emergencyContactNumber: "",
    // secondaryContact: "",
    // secondaryEmail: "",
    // secondaryCountryCode: "",
    // secondaryContactNumber: "",
    srDays: "",
    // notificationDays: "",
    clientNameStatus: "unchecked",
    industryTypeStatus: "unchecked",
    hiringTypeStatus: "unchecked",
    primaryContactStatus: "unchecked",
    addressStatus: "unchecked",
    mapLocationStatus: "unchecked",
    primaryEmailStatus: "unchecked",
    primaryCountryCodeStatus: "unchecked",
    contactNumberStatus: "unchecked",
    // emergencyContactNumberStatus: "unchecked",
    // secondaryContactStatus: "unchecked",
    // secondaryEmailStatus: "unchecked",
    // secondaryCountryCodeStatus: "unchecked",
    // secondaryContactNumberStatus: "unchecked",
    srDaysStatus: "unchecked",
    // notificationDaysStatus: "unchecked",
  });

  //edit and view data fetch
  useEffect(() => {
    // Extract the first client (or any other logic to determine which client to use)
    const client = oneClientData[0]; // Adjust the index as needed or add dynamic logic

    if (client) {
      setClientData((prevState) => ({
        ...prevState,
        clientName: client.clientName,
        industryType: {
          label: client.industry.industryType,
          value: client.industry.id,
        },
        hiringType: client.hiringType,
        primaryContact: client.primaryContactPerson,
        address: client.address,
        mapLocation: client.mapLocation,
        primaryEmail: client.mailAddress,
        primaryCountryCode: {
          label: client.countryCode,
          value: client.countryCode,
        },
        contactNumber: client.contactNumber,
        // emergencyContactNumber: client.emergencyContactNumber,
        // secondaryContact: client.secondaryContactPerson,
        // secondaryEmail: client.secondaryEmail,
        // secondaryCountryCode: {
        //   label: client.secondaryCountryCode,
        //   value: client.secondaryCountryCode,
        // },
        // secondaryContactNumber: client.secondaryContactNumber,
        srDays: client.srDays,
        // notificationDays: client.notification,
        clientNameStatus: "success",
        industryTypeStatus: "success",
        hiringTypeStatus: "success",
        primaryContactStatus: "success",
        addressStatus: "success",
        mapLocationStatus: "success",
        primaryEmailStatus: "success",
        primaryCountryCodeStatus: "success",
        contactNumberStatus: "success",
        // emergencyContactNumberStatus: "success",
        // secondaryContactStatus: "success",
        // secondaryEmailStatus: "success",
        // secondaryCountryCodeStatus: "success",
        // secondaryContactNumberStatus: "success",
        srDaysStatus: "success",
        // notificationDaysStatus: "success",
      }));
    }
  }, [oneClientData]);

  //hiringType field data fetch
  useEffect(() => {
    if (clientData.industryType !== "") {
      setClientData((prevState) => ({
        ...prevState,
        hiringType: clientData.industryType.hiringType,
        hiringTypeStatus: "success",
      }));
    }
  }, [clientData]);

  //onchange function
  const handleClientDataChange = (event, selectEvent) => {
    const changeAllowed = true;
    let formState = { ...clientData };

    if (event?.target === undefined && selectEvent) {
      if (selectEvent.name === "industryType") {
        const validIndustryRegex = new RegExp("^.{1,50}$");
        if (validIndustryRegex.test(event?.label)) {
          formState[selectEvent.name + "Status"] = event?.label
            ? "success"
            : "unchecked";
        } else {
          formState[selectEvent.name + "Status"] = "error";
        }
      } else if (
        selectEvent.name === "primaryCountryCode" ||
        selectEvent.name === "secondaryCountryCode"
      ) {
        const countryCodeRegex = new RegExp("^.{1,50}$");
        if (countryCodeRegex.test(event?.label)) {
          formState[selectEvent.name + "Status"] = event?.label
            ? "success"
            : "unchecked";
        } else {
          formState[selectEvent.name + "Status"] = "error";
        }
      }
      formState[selectEvent.name] = event;
    } else {
      switch (event.target.name) {
        case "clientName": {
          const nameRegex = new RegExp("^[A-Za-z0-9 ]{1,30}$");
          formState[event.target.name + "Status"] = nameRegex.test(
            event.target.value?.trim()
          )
            ? "success"
            : "error";
          break;
        }
        case "primaryContact":
        case "secondaryContact": {
          const contactRegex = new RegExp("^[A-Za-z ]{1,30}$");
          formState[event.target.name + "Status"] = contactRegex.test(
            event.target.value?.trim()
          )
            ? "success"
            : "error";
          break;
        }
        case "address": {
          const alphaNLengthRegex = new RegExp("^.{1,100}$");
          const inputValue = event.target.value; // Allow newlines

          // Check validation only if input is non-empty
          if (inputValue.trim() === "") {
            formState[event.target.name + "Status"] = "unchecked"; // Default state
          } else if (alphaNLengthRegex.test(inputValue)) {
            formState[event.target.name + "Status"] = "success"; // Valid input
          } else {
            // Do not show error for Enter; only show for actual invalid inputs
            formState[event.target.name + "Status"] = "success";
          }
          break;
        }
        case "mapLocation": {
          const alphaNLengthRegex = new RegExp("^.{1,50}$");
          const inputValue = event.target.value; // Allow newlines

          // Check validation only if input is non-empty
          if (inputValue.trim() === "") {
            formState[event.target.name + "Status"] = "unchecked"; // Default state
          } else if (alphaNLengthRegex.test(inputValue)) {
            formState[event.target.name + "Status"] = "success"; // Valid input
          } else {
            // Do not show error for Enter; only show for actual invalid inputs
            formState[event.target.name + "Status"] = "success";
          }
          break;
        }
        case "primaryEmail":
        case "secondaryEmail": {
          const emailRegex = new RegExp(
            "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$"
          );
          formState[event.target.name + "Status"] = emailRegex.test(
            event.target.value?.trim()
          )
            ? "success"
            : "error";
          break;
        }
        case "contactNumber":
        case "emergencyContactNumber":
        case "secondaryContactNumber": {
          const numberRegex = new RegExp("^([0-9]{10})$");
          formState[event.target.name + "Status"] = numberRegex.test(
            event.target.value?.trim()
          )
            ? "success"
            : "error";
          break;
        }
        case "srDays": {
          const probationRegex = new RegExp("^([0-9]{1,3})$");
          formState[event.target.name + "Status"] = probationRegex.test(
            event.target.value?.trim()
          )
            ? "success"
            : "error";
          break;
        }
        case "notificationDays": {
          const notificationRegex = new RegExp("^([0-9]{1,2})$");
          formState[event.target.name + "Status"] = notificationRegex.test(
            event.target.value?.trim()
          )
            ? "success"
            : "error";
          break;
        }
        default:
          break;
      }
      if (changeAllowed) {
        formState[event.target.name] = event.target.value;
      }
    }
    setClientData(formState);
  };

  const isFormValid = () => {
    return (
      clientData.clientNameStatus === "success" &&
      clientData.industryTypeStatus === "success" &&
      clientData.hiringTypeStatus === "success" &&
      clientData.primaryContactStatus === "success" &&
      clientData.addressStatus === "success" &&
      clientData.mapLocationStatus === "success" &&
      clientData.primaryEmailStatus === "success" &&
      clientData.primaryCountryCodeStatus === "success" &&
      clientData.contactNumberStatus === "success" &&
      // clientData.emergencyContactNumberStatus === "success" &&
      // clientData.secondaryContactStatus === "success" &&
      // clientData.secondaryEmailStatus === "success" &&
      // clientData.secondaryCountryCodeStatus === "success" &&
      // clientData.secondaryContactNumberStatus === "success" &&
      clientData.srDaysStatus === "success"
      // clientData.notificationDaysStatus === "success"
    );
  };

  //reset form
  const resetForm = () => {
    setClientData({
      clientName: "",
      industryType: "",
      hiringType: "",
      primaryContact: "",
      address: "",
      mapLocation: "",
      primaryEmail: "",
      primaryCountryCode: "",
      contactNumber: "",
      // emergencyContactNumber: "",
      // secondaryContact: "",
      // secondaryEmail: "",
      // secondaryCountryCode: "",
      // secondaryContactNumber: "",
      srDays: "",
      // notificationDays: "",
      clientNameStatus: "unchecked",
      industryTypeStatus: "unchecked",
      hiringTypeStatus: "unchecked",
      primaryContactStatus: "unchecked",
      addressStatus: "unchecked",
      mapLocationStatus: "unchecked",
      primaryEmailStatus: "unchecked",
      primaryCountryCodeStatus: "unchecked",
      contactNumberStatus: "unchecked",
      // emergencyContactNumberStatus: "unchecked",
      // secondaryContactStatus: "unchecked",
      // secondaryEmailStatus: "unchecked",
      // secondaryCountryCodeStatus: "unchecked",
      // secondaryContactNumberStatus: "unchecked",
      srDaysStatus: "unchecked",
      // notificationDaysStatus: "unchecked",
    });
    formClose();
  };

  const onSubmitOpen = () => {
    handleOpenDialog();
    setDialogData({
      title: `${oneClientData.length > 0 ? "Update" : "Create"} client ?`,
      content: `Are you sure you want to ${
        oneClientData.length > 0 ? "Update" : "Create"
      } client ?`,
      onConfirm: () => handleSubmit(),
    });
  };

  //   {
  //   "input": {
  //     "clientName": "Test Client",
  //     "industry": 1,
  //     "hiringType": "Permanent",
  //     "primaryContactPerson": "John Doe",
  //     "address": "123 Business St",
  //     "mapLocation": "12.9716° N, 77.5946° E",
  //     "mailAddress": "testclient@example.com",
  //     "countryCode": "+91",
  //     "contactNumber": "9876543210",
  //     "srDays": "90",
  //     "createdBy": "admin",
  //     "updatedBy": "admin"
  //   }
  // }

  //submit form
  const handleSubmit = async () => {
    const variables = {
      clientName: clientData.clientName,
      industry: clientData.industryType.value,
      hiringType: clientData.hiringType,
      primaryContactPerson: clientData.primaryContact,
      address: clientData.address,
      mapLocation: clientData.mapLocation,
      mailAddress: clientData.primaryEmail,
      countryCode: clientData.primaryCountryCode.value,
      contactNumber: clientData.contactNumber,
      srDays: clientData.srDays,
    };
    try {
      //update api call
      if (oneClientData.length > 0) {
        variables.id = oneClientData[0].id;
        variables.updatedBy = isuser.username;
        const response = await updateItem(UPDATECREATECLIENT, {
          input: variables,
        });
        if (response?.updateClient?.success === true) {
          setPopup({
            open: true,
            message: response?.updateClient?.message,
            severity: "success",
          });
        } else {
          setPopup({
            open: true,
            message: response?.updateClient?.message,
            severity: "error",
          });
        }
      } else {
        //Post api call
        variables.createdBy = isuser.username;
        const response = await postItem(CREATECLIENT, { input: variables });
        if (response?.createClient?.success === true) {
          setPopup({
            open: true,
            message: response?.createClient?.message,
            severity: "success",
          });
        } else {
          setPopup({
            open: true,
            message: response?.createClient?.message,
            severity: "error",
          });
        }
      }
    } catch (error) {
      console.error(error);
      setPopup({
        open: true,
        message: error,
        severity: "error",
      });
    } finally {
      resetForm();
      getClientData();
    }
  };

  return (
    <Paper sx={{ p: 4, mx: "auto" }}>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", gap: 4 }}>
          <IconButton onClick={resetForm}>
            <ArrowBackIcon sx={{ color: "#000" }} />
          </IconButton>
          <MaterialTypography
            sx={{ fontSize: "18px", fontWeight: "bold", mt: 2 }}
            mb={2}
          >
            {oneClientData.length > 0 ? "Update" : "Add"} Client
          </MaterialTypography>
        </Box>
        <IconButton onClick={resetForm}>
          <ClearIcon sx={{ color: "#000" }} />
        </IconButton>
      </Box>

      <form>
        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Client Name
              </MaterialTypography>
              <MaterialInput
                name="clientName"
                disabled={isView}
                value={clientData.clientName}
                onChange={handleClientDataChange}
                error={clientData.clientNameStatus === "error"}
                success={clientData.clientNameStatus === "success"}
              />
            </FormControl>
            {clientData.clientNameStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Client Name Max 30 Variable Characters.
              </MaterialTypography>
            )}
          </Grid>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Industry Type
              </MaterialTypography>
              <MaterialSelect
                name="industryType"
                value={clientData.industryType}
                onChange={(event, selectEvent) =>
                  handleClientDataChange(event, selectEvent)
                }
                options={industryData}
                error={clientData.industryTypeStatus === "error"}
                success={clientData.industryTypeStatus === "success"}
                isDisabled={isView}
              />
            </FormControl>
            {clientData.industryTypeStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                select industry type
              </MaterialTypography>
            )}
          </Grid>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Hiring Type
              </MaterialTypography>
              <MaterialInput
                name="hiringType"
                value={clientData.hiringType}
                error={clientData.hiringTypeStatus === "error"}
                success={clientData.hiringTypeStatus === "success"}
                disabled
              />
            </FormControl>
            {clientData.hiringTypeStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Hiring Type Max 20 Variable Characters.
              </MaterialTypography>
            )}
          </Grid>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Primary Contact Person
              </MaterialTypography>
              <MaterialInput
                name="primaryContact"
                value={clientData.primaryContact}
                onChange={handleClientDataChange}
                error={clientData.primaryContactStatus === "error"}
                success={clientData.primaryContactStatus === "success"}
                disabled={isView}
              />
            </FormControl>
            {clientData.primaryContactStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Max 30 Alpha Characters.
              </MaterialTypography>
            )}
          </Grid>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Address
              </MaterialTypography>
              <MaterialInput
                name="address"
                multiline
                rows={3}
                value={clientData.address}
                onChange={handleClientDataChange}
                error={clientData.addressStatus === "error"}
                success={clientData.addressStatus === "success"}
                disabled={isView}
              />
            </FormControl>
            {clientData.addressStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Max 100 Variable Characters
              </MaterialTypography>
            )}
          </Grid>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Map Location
              </MaterialTypography>
              <MaterialInput
                name="mapLocation"
                value={clientData.mapLocation}
                onChange={handleClientDataChange}
                error={clientData.mapLocationStatus === "error"}
                success={clientData.mapLocationStatus === "success"}
                disabled={isView}
              />
              {clientData.mapLocationStatus === "error" && (
                <MaterialTypography
                  variant="caption"
                  color="error"
                  sx={{ mt: 0.5, display: "block" }}
                >
                  Max 50 Variable Characters
                </MaterialTypography>
              )}
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Email
              </MaterialTypography>
              <MaterialInput
                name="primaryEmail"
                value={clientData.primaryEmail}
                onChange={handleClientDataChange}
                error={clientData.primaryEmailStatus === "error"}
                success={clientData.primaryEmailStatus === "success"}
                disabled={isView}
              />
            </FormControl>
            {clientData.primaryEmailStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Enter correct email (E.g: example@gmail.com).
              </MaterialTypography>
            )}
          </Grid>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Country Code
              </MaterialTypography>
              <MaterialSelect
                name="primaryCountryCode"
                value={clientData.primaryCountryCode}
                onChange={(event, selectEvent) =>
                  handleClientDataChange(event, selectEvent)
                }
                options={countryState.countryCodeOptions}
                error={clientData.primaryCountryCodeStatus === "error"}
                success={clientData.primaryCountryCodeStatus === "success"}
                isDisabled={isView}
              />
            </FormControl>
            {clientData.primaryCountryCodeStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                select country code
              </MaterialTypography>
            )}
          </Grid>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Contact Number
              </MaterialTypography>
              <MaterialInput
                name="contactNumber"
                value={clientData.contactNumber}
                onChange={(event) => {
                  const value = event.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    handleClientDataChange(event, null); // Call handler only if valid
                  }
                }}
                error={clientData.contactNumberStatus === "error"}
                success={clientData.contactNumberStatus === "success"}
                disabled={isView}
              />
            </FormControl>
            {clientData.contactNumberStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Max 10 numeric Characters.
              </MaterialTypography>
            )}
          </Grid>
          {/*           
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Emergency Contact Number
              </MaterialTypography>
              <MaterialInput
                name="emergencyContactNumber"
                value={clientData.emergencyContactNumber}
                onChange={(event) => {
                  const value = event.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    handleClientDataChange(event, null); // Call handler only if valid
                  }
                }}
                error={clientData.emergencyContactNumberStatus === "error"}
                success={clientData.emergencyContactNumberStatus === "success"}
                disabled={isView}
                inputProps={{ maxLength: 50 }}
              />
            </FormControl>
            {clientData.emergencyContactNumberStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Max 10 numeric Characters.
              </MaterialTypography>
            )}
          </Grid>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Secondary Contact Person
              </MaterialTypography>
              <MaterialInput
                name="secondaryContact"
                value={clientData.secondaryContact}
                onChange={handleClientDataChange}
                error={clientData.secondaryContactStatus === "error"}
                success={clientData.secondaryContactStatus === "success"}
                disabled={isView}
              />
            </FormControl>
            {clientData.secondaryContactStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Max 20 Alpha Characters.
              </MaterialTypography>
            )}
          </Grid>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Secondary Email Address
              </MaterialTypography>
              <MaterialInput
                name="secondaryEmail"
                value={clientData.secondaryEmail}
                onChange={handleClientDataChange}
                error={clientData.secondaryEmailStatus === "error"}
                success={clientData.secondaryEmailStatus === "success"}
                disabled={isView}
                inputProps={{ maxLength: 50 }}
              />
            </FormControl>
            {clientData.secondaryEmailStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Enter correct email (E.g: example@gmail.com).
              </MaterialTypography>
            )}
          </Grid>
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Country Code
              </MaterialTypography>
              <MaterialSelect
                name="secondaryCountryCode"
                value={clientData.secondaryCountryCode}
                onChange={handleClientDataChange}
                options={countryState.countryCodeOptions}
                isClearable
                error={clientData.secondaryCountryCodeStatus === "error"}
                success={clientData.secondaryCountryCodeStatus === "success"}
                isDisabled={isView}
              />
            </FormControl>
            {clientData.secondaryCountryCodeStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                select country code.
              </MaterialTypography>
            )}
          </Grid>

          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Contact Number
              </MaterialTypography>
              <MaterialInput
                name="secondaryContactNumber"
                value={clientData.secondaryContactNumber}
                onChange={(event) => {
                  const value = event.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    handleClientDataChange(event, null); // Call handler only if valid
                  }
                }}
                error={clientData.secondaryContactNumberStatus === "error"}
                success={clientData.secondaryContactNumberStatus === "success"}
                disabled={isView}
              />
            </FormControl>
            {clientData.secondaryContactNumberStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Max 10 numeric Characters.
              </MaterialTypography>
            )}
          </Grid> */}
          <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                SR Days
              </MaterialTypography>
              <MaterialInput
                name="srDays"
                value={clientData.srDays}
                onChange={(event) => {
                  const value = event.target.value;
                  if (/^\d{0,3}$/.test(value)) {
                    handleClientDataChange(event, null); // Call handler only if valid
                  }
                }}
                error={clientData.srDaysStatus === "error"}
                success={clientData.srDaysStatus === "success"}
                disabled={isView}
              />
            </FormControl>
            {clientData.srDays === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Max 3 numerical Characters.
              </MaterialTypography>
            )}
          </Grid>
          {/* <Grid size={{ xs: 12, md: 6, sm: 6 }}>
            <FormControl fullWidth sx={{ mt: 2 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Notification Days
              </MaterialTypography>
              <MaterialInput
                name="notificationDays"
                value={clientData.notificationDays}
                onChange={(event) => {
                  const value = event.target.value;
                  if (/^\d{0,2}$/.test(value)) {
                    handleClientDataChange(event, null); // Call handler only if valid
                  }
                }}
                error={clientData.notificationDaysStatus === "error"}
                success={clientData.notificationDaysStatus === "success"}
                disabled={isView}
              />
            </FormControl>
            {clientData.notificationDaysStatus === "error" && (
              <MaterialTypography
                variant="caption"
                color="error"
                sx={{ mt: 0.5, display: "block" }}
              >
                Max 2 numerical Characters.
              </MaterialTypography>
            )}
          </Grid> */}
        </Grid>

        {!isView && (
          <Box display="flex" justifyContent="space-around" mt={3}>
            <MaterialButton
              variant="contained"
              sx={{
                background: colors.buttonColor,
                color: "#fff",
                textTransform: "capitalize",
              }}
              disabled={!isFormValid()}
              onClick={onSubmitOpen}
            >
              {oneClientData.length > 0 ? "Update" : "Submit"}
            </MaterialButton>
            <MaterialButton
              onClick={resetForm}
              variant="outlined"
              color="error"
            >
              Cancel
            </MaterialButton>
          </Box>
        )}
      </form>
    </Paper>
  );
};

export default AddClientForm;
